import { graphColorsForEachAdTypes } from '../../../data/data'

const doughnutPalette = [
  graphColorsForEachAdTypes.pop,
  graphColorsForEachAdTypes.get,
  graphColorsForEachAdTypes.leased,
  graphColorsForEachAdTypes.error,
  '#F59E0B',
  '#14B8A6',
  '#8B5CF6',
  '#EC4899',
  '#22C55E',
  '#F97316',
  '#06B6D4',
  '#84CC16',
  '#EF4444',
  '#6366F1',
  '#A855F7',
  '#0EA5E9',
  '#10B981',
  '#EAB308',
  '#F43F5E',
  '#3B82F6',
  '#4ADE80',
  '#FB7185',
  '#2DD4BF',
  '#C084FC'
]

export class GraphHelper {
  static generateDoughNutGraphData = ({ chartTitle, labels, data, latestError, palette }) => {
    const colors = palette || doughnutPalette
    return {
      chartTitle,
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: colors,
            borderColor: colors,
            hoverBackgroundColor: colors,
            borderWidth: 0
          }
        ]
      },
      hasDataMoreThanZero: true,
      latestError: latestError || {}
    }
  }
  static generateLineGraphData = ({ chartTitle, labels, data }) => {
    return {
      labels: labels,
      datasets: [
        {
          label: chartTitle,
          data,
          fill: false,
          borderColor: 'rgba(75,192,192,1)',
          backgroundColor: 'rgba(75,192,192,0.2)',
          tension: 0.4,
          pointRadius: 5,
          pointHoverRadius: 7
        }
      ]
    }
  }

  static getLineChartOptions = () => {
    return {
      cutoutPercentage: 70,
      responsive: true,
      legend: {
        display: true,
        position: 'top',
        margin: {
          top: 0,
          bottom: 0
        },
        labels: {
          boxWidth: 8,
          fontSize: 10,
        },
        onClick: function (e, legendItem) {
          e.preventDefault();
        }
      },
      layout: {
        autoPadding: false,
        padding: {
          bottom: 0,
          top: 0
        }
      },
      maintainAspectRatio: false
    }
  }

  static getdoughnutChartOptions = () => {
    return {
      cutoutPercentage: 70,
      responsive: true,
      legend: {
        display: true,
        position: 'right',
        margin: {
          top: 0,
          bottom: 0
        },
        labels: {
          boxWidth: 8,
          fontSize: 10,
        },
        onClick: function (e, legendItem) {
          e.preventDefault();
        }
      },
      layout: {
        autoPadding: false,
        padding: {
          bottom: 0,
          top: 0
        }
      },
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            // tooltipItem.index is the slice index
            return data.labels[tooltipItem.index]; // shows only "POP(6788)" etc.
          }
        }
      },
      maintainAspectRatio: false
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/components/charts/GraphHelper.js